import { Children, isValidElement, ReactElement, ReactNode } from 'react'

type ElementWithChildren = ReactElement<{ children?: ReactNode }>

interface CollectStringsParams {
  element: ElementWithChildren
  strings: string[]
}

const collectStrings = ({ element, strings }: CollectStringsParams) => {
  Children.forEach(element.props.children, child => {
    if (isValidElement<{ children?: ReactNode }>(child)) {
      collectStrings({ element: child, strings })
    } else if (typeof child === 'string') {
      strings.push(child)
    }
  })
}

export const reactToString = (element: ElementWithChildren) => {
  const strings: string[] = []
  collectStrings({ element, strings })
  return strings
}
